// extracted by mini-css-extract-plugin
export default {"Wrapper":"Layout_Wrapper__393Qk","Navcontainer":"Layout_Navcontainer__1U7zx","nav-hide":"Layout_nav-hide__Hoou6","main-content":"Layout_main-content__ydsuJ"};